import Navbar from "../../components/layout/Navbar";
import MainLayout from "../../components/layout/MainLayout";
import { Link } from "react-router-dom";

export default function ChiSiamoPage() {

  return (

    <MainLayout>

      <Navbar />

      {/* HERO */}
      <section className="relative h-[60vh] flex items-center justify-center text-white">

        <img
          src="/images/team/team-hero.jpg"
          className="absolute inset-0 w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-black/40"></div>

        <div className="relative text-center px-6">

          <h1 className="text-5xl md:text-6xl font-serif mb-6">
            Chi siamo
          </h1>

          <p className="max-w-xl mx-auto text-lg opacity-90">
            Un centro di estetica avanzata dedicato alla bellezza autentica
            e ai risultati reali.
          </p>

        </div>

      </section>


      {/* STORIA */}
      <section className="py-24 px-6">

        <div className="max-w-4xl mx-auto text-center">

          <h2 className="text-4xl font-serif mb-10">
            La nostra filosofia
          </h2>

          <p className="text-lg text-gray-600 leading-relaxed">
            Alkimya Estetica Avanzata nasce con l'obiettivo di offrire
            trattamenti altamente professionali attraverso tecnologie
            innovative e protocolli personalizzati.
            <br /><br />
            Ogni percorso inizia con un’analisi approfondita della pelle
            e delle esigenze della persona, perché ogni trattamento deve
            essere unico.
            <br /><br />
            La nostra missione è valorizzare la bellezza naturale
            attraverso risultati concreti e duraturi.
          </p>

        </div>

      </section>


     {/* TEAM */}
<section className="py-24 bg-alkimya-beige px-6">

  <div className="max-w-7xl mx-auto">

    <h2 className="text-4xl font-serif text-center mb-16">
      Il nostro team
    </h2>

    <div className="grid md:grid-cols-4 gap-12">

      {/* MEMBRO 1 */}
      <div className="text-center">

        <img
          src="/images/team/team1.jpg"
          className="rounded-2xl mb-6 shadow-lg w-full object-cover"
        />

        <h3 className="text-xl font-semibold">
          Laura Galli
        </h3>

        <p className="text-alkimya-gray">
          CEO Alkimya estetica avanzata
        </p>

      </div>

      {/* MEMBRO 2 */}
      <div className="text-center">

        <img
          src="/images/team/team2.jpg"
          className="rounded-2xl mb-6 shadow-lg w-full object-cover"
        />

        <h3 className="text-xl font-semibold">
          Asia Meloni
        </h3>

        <p className="text-alkimya-gray">
          PMU Artist e specialista trattamenti corpo
        </p>

      </div>

      {/* MEMBRO 3 */}
      <div className="text-center">

        <img
          src="/images/team/team3.jpg"
          className="rounded-2xl mb-6 shadow-lg w-full object-cover"
        />

        <h3 className="text-xl font-semibold">
          Denise Paolini
        </h3>

        <p className="text-alkimya-gray">
          Nail Artist e specialista trattamenti viso
        </p>

      </div>

      {/* MEMBRO 4 */}
      <div className="text-center">

        <img
          src="/images/team/team4.jpg"
          className="rounded-2xl mb-6 shadow-lg w-full object-cover"
        />

        <h3 className="text-xl font-semibold">
          Eleonora Pannone
        </h3>

        <p className="text-alkimya-gray">
          Massage Therapist e specialista trattamenti corpo
        </p>

      </div>

    </div>

  </div>

</section>

      {/* TRUSTPILOT */}
      <section className="py-24 px-6 text-center">

        <h2 className="text-4xl font-serif mb-6">
          Le opinioni dei nostri clienti
        </h2>

        <p className="text-gray-600 mb-10">
          Scopri cosa dicono i nostri clienti su Trustpilot
        </p>

        <a
          href="https://www.trustpilot.com/review/alkimyaestetica.com"
          target="_blank"
          className="inline-flex items-center gap-3
          bg-black text-white px-8 py-4 rounded-full
          hover:scale-105 transition"
        >
          Leggi le recensioni
        </a>

      </section>


      {/* CTA */}
      <section className="py-24 bg-[#f8f5f1] text-center">

        <h2 className="text-3xl font-serif mb-6">
          Prenota la tua consulenza
        </h2>

        <Link
          to="/consulenza"
          className="bg-alkimya-beige text-white px-8 py-4 rounded-full hover:scale-105 transition"
        >
          Prenota ora
        </Link>

      </section>

    </MainLayout>

  );

}